import { ZgBrand } from '@zg-rentals/ts-capps-client';

export const BRANDS = {
  zillow: 'zillow',
  hotpads: 'hotpads',
  trulia: 'trulia',
};

const ZG_BRANDS: Record<string, ZgBrand> = {
  [BRANDS.zillow]: ZgBrand.ZILLOW,
  [BRANDS.hotpads]: ZgBrand.HOTPADS,
  [BRANDS.trulia]: ZgBrand.TRULIA,
};

export function getZgBrand(brand: string): ZgBrand | undefined {
  return ZG_BRANDS[brand];
}
